import { useEffect } from 'react'

// キーボードのみで「全 SOAP コピー → 完了へ移動」を実行する shortcut (Ctrl+Shift+C)。
// input/textarea/contenteditable にフォーカスがある間は無効。e.code で keyboard layout 非依存。
export const useCopyShortcut = (onCopy: () => void) => {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (!e.ctrlKey || !e.shiftKey || e.code !== 'KeyC' || e.repeat) return
      const t = e.target as HTMLElement | null
      if (
        t &&
        (t.tagName === 'INPUT' ||
          t.tagName === 'TEXTAREA' ||
          t.isContentEditable)
      )
        return
      e.preventDefault()
      onCopy()
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onCopy])
}
